import AddEditDonationAttributionsRow from "./AddEditDonationAttributionsRow/AddEditDonationAttributionsRow";
import { CustomDate } from "../../../../models/custom-date/custom-date";
import { DonationAttributionRef } from "../../../../models/donation-attributions/donation-attribution-ref";
import { TransactionDTO } from "../../../../models/transactions";

import ConfirmationRemoveItemDialog from "../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";
import { Amounts, HeaderRow, MainBlock, StyledTableCell, TableBodyRow } from "../styles";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const DonationAttributions = ({
  transaction: { attributionsOfTheReceivedDonation, legalEntity, currency, transactionDate },
  readOnly = false,
  handleChange,
}: Props) => {
  // const [shown, setShown] = useState<boolean>(false);

  const handleChangeDonation = (value: DonationAttributionRef, idx: number): void => {
    idx < 0
      ? handleChange && handleChange("attributionsOfTheReceivedDonation", [...attributionsOfTheReceivedDonation, value])
      : handleChange &&
        handleChange("attributionsOfTheReceivedDonation", [
          ...attributionsOfTheReceivedDonation.slice(0, idx),
          value,
          ...attributionsOfTheReceivedDonation.slice(idx + 1),
        ]);
  };

  const handleRemoveDonation = (idx: number): void =>
    handleChange &&
    handleChange("attributionsOfTheReceivedDonation", [
      ...attributionsOfTheReceivedDonation.slice(0, idx),
      ...attributionsOfTheReceivedDonation.slice(idx + 1),
    ]);

  return (
    <>
      <MainBlock>
        <HeaderRow container>
          <StyledTableCell
            flex={2}
            align={"left"}
          >
            Attributions of the received donation
          </StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Amount
          </StyledTableCell>
          <StyledTableCell flex={1}>Exchange rate</StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Booked amount
          </StyledTableCell>
          {!readOnly && (
            <StyledTableCell width={100}>
              <AddEditDonationAttributionsRow
                handleChangeDonation={(value) => handleChangeDonation(value, -1)}
                legalEntity={legalEntity}
                currency={currency}
                date={CustomDate.ToDate(transactionDate) as Date}
              />
            </StyledTableCell>
          )}
        </HeaderRow>

        {attributionsOfTheReceivedDonation?.map((donation, idx) => {
          return (
            <TableBodyRow
              container
              key={donation.id}
            >
              <StyledTableCell
                flex={2}
                align={"left"}
              >
                {donation?.project?.name ?? ""}
              </StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+donation?.amount).toLocaleCustom()} ${donation?.currency?.code ?? ""}`}
              >
                <Amounts>{`${(+donation?.amount).toLocaleCustom()} ${donation?.currency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              <StyledTableCell flex={1}>{donation?.exchangeRate}</StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+donation?.bookedAmount).toLocaleCustom()} ${donation?.bookedCurrency?.code ?? ""}`}
              >
                <Amounts>{`${(+donation?.bookedAmount).toLocaleCustom()} ${
                  donation?.bookedCurrency?.code ?? ""
                }`}</Amounts>
              </StyledTableCell>
              {!readOnly && (
                <StyledTableCell width={100}>
                  <AddEditDonationAttributionsRow
                    handleChangeDonation={(value) => handleChangeDonation(value, idx)}
                    legalEntity={legalEntity}
                    item={donation}
                    date={CustomDate.ToDate(transactionDate) as Date}
                  />
                  <ConfirmationRemoveItemDialog
                    index={idx}
                    handleRemove={handleRemoveDonation}
                  />
                </StyledTableCell>
              )}
            </TableBodyRow>
          );
        })}
      </MainBlock>
    </>
  );
};

export default DonationAttributions;
